import BaseModel from '../BaseModel';

export default class Profession extends BaseModel {
  static entity = 'professions';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      find(query) {
        return this.get('professions/find', { params: { query } }, { save: false });
      },
    },
  }
}
